import React from "react";

import { Controller, useFormContext } from "react-hook-form";
import { v4 } from "uuid";

import { AutocompleteCodeInput } from "src/base-components/CodeInput/EditorCodeInput";
import { Pill } from "src/design-system/Pill";
import { Tooltip } from "src/design-system/Tooltip";
import { useIsFieldHighlighted } from "src/flowGraph/canvasSearch/CanvasSearchHighlightContext";
import { RuleNodeV2Form } from "src/ruleNodeV2Editor/types";

type Props = {
  branchIndex: number;
  index: number;
  name: string;
  immutable: boolean;
  lazyInputs: boolean;
  fieldError: string | undefined;
};

export const BranchEffect: React.FC<Props> = ({
  branchIndex,
  index,
  name,
  immutable,
  lazyInputs,
  fieldError,
}) => {
  const { control, register, getValues } = useFormContext<RuleNodeV2Form>();
  const effectId = getValues(`branches.${branchIndex}.effects.${index}.id`);
  const isSearchHighlighted = useIsFieldHighlighted(effectId);

  return (
    <div className="flex items-center gap-x-2 font-inter-normal-12px text-gray-700">
      <span className="font-inter-medium-12px">Then set value of</span>
      <Tooltip placement="top" title={`data.${name}`}>
        <div className="max-w-50">
          <Pill variant="green" fullWidth>
            <Pill.Text>data.{name}</Pill.Text>
          </Pill>
        </div>
      </Tooltip>
      <span className="font-inter-medium-12px">to</span>
      <input
        defaultValue={v4()}
        type="hidden"
        {...register(`branches.${branchIndex}.effects.${index}.id`)}
      />
      <Controller
        control={control}
        defaultValue=""
        name={`branches.${branchIndex}.effects.${index}.value`}
        render={({ field }) => (
          <AutocompleteCodeInput
            dataLoc={`rule-node-v2-branches-${branchIndex}-effects-${index}-value`}
            disabled={immutable}
            error={fieldError}
            isSearchHighlighted={isSearchHighlighted}
            lazy={lazyInputs}
            placeholder='Strings should be quoted, e.g. "Decide"'
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />
    </div>
  );
};
